import { ReactNode } from 'react';
import { TourProvider } from '@reactour/tour';
import { OnboardingProvider } from 'contextProviders/OnboardingProvider';
import OnboardingTourController from './tour/OnboardingTourController';
import TourScrollLock from './tour/TourScrollLock';
import TourPeekButton from './tour/TourPeekButton';
import TourPopupLayer from './tour/TourPopupLayer';
import { tourStyles } from './tour/tourStyles';

// Single wiring point for the guided-tour stack: the onboarding data context, the
// reactour provider (with our config/styles), and the controllers that DON'T need
// the router — the outcome logger and the scroll lock. Router-scoped controllers
// (TourGuard, IntroTourAutostart) live in TourRouteWatchers, which must render
// inside the BrowserRouter. Wrap the app content with this.
const OnboardingTourProvider = ({ children }: { children: ReactNode }) => (
	<OnboardingProvider>
		<TourProvider
			steps={[]}
			styles={tourStyles}
			showBadge={false}
			showCloseButton={false}
			showNavigation={false}
			showPrevNextButtons={false}
			onClickMask={() => {}}
			disableWhenSelectorFalsy
		>
			<OnboardingTourController />
			<TourScrollLock />
			<TourPeekButton />
			<TourPopupLayer />
			{children}
		</TourProvider>
	</OnboardingProvider>
);

export default OnboardingTourProvider;
